import {
  DuplicateIcon,
  EyeIcon,
  UserGroupIcon,
} from "@heroicons/react/outline";
import { useHistory, useRouteMatch } from "react-router-dom";
import useMembers from "../../hooks/DatabseCollection/useMembers";

const RoomsCardData = ({ title, createdUser, language, roomId }) => {
  let { path } = useRouteMatch();
  const history = useHistory();
  const [memberData] = useMembers(roomId);

  const goTo = () => {
    history.push(`${path}/discussioin/${roomId}`);
  };

  return (
    <div
      onClick={goTo}
      className="bg-white flex flex-col space-y-3 px-5 mt-6 rounded-md shadow hover:shadow-md border border-gray-50 cursor-pointer"
    >
      <div className="flex py-2 items-center space-x-4 border-b-2 border-gray-100">
        <UserGroupIcon className="h-8 bg-green-600 text-white px-2 py-2 rounded-full shadow-md" />
        <h1 className=" text-lg text-gray-600">{title}</h1>
      </div>
      <div className="py-1">
        <h1 className="">{createdUser}</h1>
      </div>
      <div className="flex items-center space-x-7 border-b border-gray-100 pb-3">
        <h1 className="text-sm text-gray-600">Programming Language :</h1>
        <p className="px-4 py-1 bg-gray-200 text-black text-xs rounded-full shadow">
          {language}
        </p>
      </div>
      <div className="flex items-center justify-between space-x-3 pb-2">
        <div className="flex items-center space-x-3">
          <h1>Share Via</h1>
          <DuplicateIcon className="h-5 text-gray-500" />
        </div>
        <div className="flex items-center space-x-2">
          <EyeIcon className="h-5 text-gray-500" />
          <span>{memberData?.length}</span>
        </div>
      </div>
    </div>
  );
};

export default RoomsCardData;
